module.exports = __webpack_public_path__ + "media/images/badges/stride/milestone-3_inactive-a2bd17e7ff2ba77b09a255dc910c0193.svg";